import { useCallback } from 'react';

import * as server from '../server';

export const useGetDetailedTransactionHistory = () => {
    return useCallback(async ({
        cancellations,
        corrections,
        endTime,
        excludePaymentRequests,
        historyRequestSummary,
        pagingRequestParams,
        reason,
        startTime,
        status,
        transactionCode,
        type
    }) => {
        const response = await server.getDetailedTransactionHistory({
            cancellations,
            corrections,
            endTime,
            excludePaymentRequests,
            historyRequestSummary,
            pagingRequestParams,
            reason,
            startTime,
            status,
            transactionCode,
            type
        });

        const {
            pagingResponseParams = {},
            transactions = [],
            historyResponseSummary = {}
        } = response?.data ?? {};

        return {
            pagingResponseParams,
            transactions,
            historyResponseSummary
        };
    }, []);
};
